import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-16'],
    padding: anatomy['size-16'],
    background: colors.brandGhostBackground,
    borderRadius: anatomy.borderRadiusM,
    justifyContent: 'space-between',
  },
  form: {
    display: 'flex',
    justifyContent: 'space-between',
    ':not(#__unused__) input': {
      flexShrink: '0',
    },
    gap: anatomy['space-8'],
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-4'],
    minHeight: anatomy['space-24'],
    wordBreak: 'break-word',
    wordWrap: 'break-word',
    color: colors.primaryText,
  },
  nameChosen: {
    color: colors.accentText,
  },
  date: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightBody-5'],
    color: colors.tertiaryText,
  },
  watch: {
    display: 'flex',
    gap: anatomy['space-4'],
    alignItems: 'center',
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightBody-5'],
    color: colors.accentText,
    width: 'min-content',
    ':hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
});
